import React, { createContext, useContext, useState, useEffect } from 'react';

interface FeatureFlags {
  aiPrediction: boolean;
  anomalyDetection: boolean;
  intelligentRightsizing: boolean;
  advancedAnalytics: boolean;
}

interface FeatureContextType {
  features: FeatureFlags;
  isPremium: boolean;
  toggleFeature: (feature: keyof FeatureFlags) => void;
  upgradeRequired: () => void;
}

const FeatureContext = createContext<FeatureContextType | undefined>(undefined);

export const FeatureProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPremium, setIsPremium] = useState(false);
  const [features, setFeatures] = useState<FeatureFlags>({
    aiPrediction: false,
    anomalyDetection: false,
    intelligentRightsizing: false,
    advancedAnalytics: false,
  });

  useEffect(() => {
    // Simular verificação de plano do usuário
    const userPlan = localStorage.getItem('userPlan') || 'basic';
    const premium = userPlan === 'premium';
    setIsPremium(premium);
    
    if (premium) {
      setFeatures({
        aiPrediction: true,
        anomalyDetection: true,
        intelligentRightsizing: true,
        advancedAnalytics: true,
      });
    }
  }, []);

  const toggleFeature = (feature: keyof FeatureFlags) => {
    if (!isPremium) {
      upgradeRequired();
      return;
    }
    
    setFeatures(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  const upgradeRequired = () => {
    // Mostrar modal de upgrade
    console.log('Upgrade required for premium features');
  };

  return (
    <FeatureContext.Provider value={{ features, isPremium, toggleFeature, upgradeRequired }}>
      {children}
    </FeatureContext.Provider>
  );
};

export const useFeatures = () => {
  const context = useContext(FeatureContext);
  if (!context) {
    throw new Error('useFeatures must be used within FeatureProvider');
  }
  return context;
};